import type { VoidComponent } from "solid-js";
import { untrack } from "solid-js";
import { toField } from "../../../fields/fields";
import type { Id } from "@thisbeyond/solid-dnd";
import { createDraggable, createDroppable } from "@thisbeyond/solid-dnd";
import DropZone from "../../../components/field/dropZone/DropZone";
import { useTranslation } from "../../../state/i18n";
import type { FieldConfig } from "../../../fields/types";

const Moveable: VoidComponent<{ item: FieldConfig; ignoredZones: Id[] }> = (props) => {
  const { uid, type } = untrack(() => props.item);
  const { t } = useTranslation();
  const field = toField(type);
  const draggable = createDraggable(uid.toString(), {
    overlay: () => <field.OverlayItem />,
    type: field.type,
  });
  const droppable = createDroppable(uid.toString());

  return (
    <article aria-label={`${t(field.titleKey)} - ${field.displayLabel(props.item.properties)}`} class="relative">
      {/* oxlint-disable-next-line better-tailwindcss/no-restricted-classes */}
      <div class="absolute top-[-5px] w-full" use:droppable>
        <DropZone
          active={droppable.isActiveDroppable && !props.ignoredZones.includes(props.item.uid.toString() as Id)}
        />
      </div>
      <div classList={{ "opacity-50": draggable.isActiveDraggable }} ref={draggable.ref}>
        <field.PreviewItem uid={props.item.uid} />
      </div>
    </article>
  );
};

export default Moveable;
